import { Col, Row, Table, Dropdown, Modal, Radio, Checkbox, Menu, Button, Space } from 'antd'

import images1 from '../../assets/images1.jfif'
import { useEffect, useState } from 'react';
import { AddShiftPlan, BASE_URL, RULE_TYPE } from '../../utils/constant';
import moment from 'moment';
import { toast } from 'react-toastify';
import DownArrow from '../../assets/icons/down-angle-color.svg';
const ShiftPlanModel = ({ 
      open,
      onCancel,
      initialData,
      location,
      shift
       }) => {
         const capitalizeFirstLetter = (str) => {
           return str?.replace(/\b\w/g, (char) => char.toUpperCase());
          };
          const [value, setValue] = useState();
          console.log('initialData',shift)
          const [selectedShift, setSelectedShift] = useState();
          const [selectedLocation, setSelectedLocation] = useState([]);
const handleShiftChange = (e) => {
    console.log('radio checked', e.target.value);
    setSelectedShift(e.target.value);
};
  const onChange = (e) => {
    console.log('radio checked', e.target.value);
    setValue(e.target.value);
  };
  const getDayNumber = (dateString) =>{

    const date = new Date(dateString);
    
    let dayNumber = date.getDay() + 1; // Adjust to start from 1 (Sunday)
    console.log('dayNumber',dayNumber)
    // If it's Sunday (0), set it to 7
    // if (dayNumber === 1) {
    //   dayNumber = 7;
    // } else {
      dayNumber--; // Adjust so Sunday is 1, Monday is 2, and so on
    // }
    return dayNumber
  }
  const getDayName = (dateString) =>{
console.log('dateString',dateString)
if(dateString){

  const date = new Date(dateString);
  
  const options = { weekday: 'long' }; // Specifies that we want the full day name
  const fullDayName = new Intl.DateTimeFormat('en-US', options).format(date);
  
  return fullDayName
}
  }
  const saveShiftPlan = async () => {

    if(!selectedShift){
      toast.error('Please Select Shift.', {
        position: toast.POSITION.TOP_RIGHT,
    });
    return;
    }
    if(!value){
      toast.error('Please Select Rule.', {
        position: toast.POSITION.TOP_RIGHT,
    });
    return;
    }
    if(selectedLocation.length == 0 ){
      toast.error('Please Select Location.', {
        position: toast.POSITION.TOP_RIGHT,
    });
    return;
    }
    const token = localStorage.getItem('authToken');
    console.log('selectedShift',value)
  const shiftPlanData = {
    ruleLogId:initialData?.selecetdStaffData?.ruleLogId,
    ruleType: value,
    fromDate: moment(initialData?.item.logDate).format("MM-DD-YYYY"),
    shiftId: selectedShift,
    mainSite: selectedLocation,
    ...(value === RULE_TYPE.All_Future_Days && { day: getDayNumber(initialData?.item.logDate) }),

  }
    try{
        const fetchData = async () => {
          const response = await fetch(`${BASE_URL}/${AddShiftPlan}`, {
            method: "POST",
             headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `${token}`,
                      
                    },
            body: JSON.stringify(shiftPlanData),
          });
          
          if (response.ok) {
            const data = await response.json();
           console.log(data)
           closeModel();
          
          } else {
            const data = await response.json();
            console.log('departmenterr',data)
           
            
          }
        };
        await fetchData();
      } catch (error) {
        console.error('Error updating designation:', error);
    }
  };

  useEffect (() => {
    setSelectedLocation(initialData?.locationData.map((item) => item?.locationId))
  }, [open])
  
        const handleLocationMenuClick = ({key}) => {
          // console.log('Clicked on:', e);
          // setLocationSelected(e.key);
          console.log('locationkey',key)
          console.log('selectedLocation',selectedLocation)
      
          const updatedItems = [...selectedLocation];
          const index = updatedItems.indexOf(key);
          if (index === -1) {
            updatedItems.push(key);
          } else {
            updatedItems.splice(index, 1);
          }
          setSelectedLocation(updatedItems);
        }
        const [openLocationDropdown, setOpen] = useState(false);
      const handleOpenChange = (nextOpen, info) => {
          setOpen(nextOpen);
      };
        const locationMenu = (
          <Menu onClick={handleLocationMenuClick}>
          {location?.map((location) => (
            <Menu.Item key={location.key}>
              <Checkbox className='mr-1' checked={selectedLocation?.includes(location.key)}/>{location.value}
              
              </Menu.Item>
          ))}
          </Menu>
        );
        function formatTimeWithAMPM(milliseconds) {
          const hours = Math.floor(milliseconds / 3600000);
          const minutes = Math.round((milliseconds % 3600000) / 60000);
        
          const formattedHours = hours % 12 || 12;
          const ampm = hours >= 12 ? 'PM' : 'AM';
        
          return `${formattedHours}:${minutes < 10 ? '0' : ''}${minutes} ${ampm}`;
        }
        const closeModel = ()=>{
          console.log('working')
          setValue()
          setSelectedLocation([])
          setSelectedShift('')
          onCancel()
          
        }
  return (
    <Modal className='ShiftPlanModel [&_.ant-modal-content]:px-4'
    title=""
       open={open}
       okButtonProps={{ style: { background: 'grey' } }}
       onCancel={closeModel}
       footer={null}
  >
  {/* < img src={showImg} alt='' /> */}
  <div>
    <div>
        <div className='ShiftPlanintroMain mb-2'>
            <div className='w-10 h-10 overflow-hidden rounded-full mx-auto mb-1.5'>
              <img className='w-full h-full object-cover' src={initialData?.selecetdStaffData?.logo} alt="" />
            </div>
            <p className='text-[17px] leading-none mt-1 mb-0.5'>{capitalizeFirstLetter(initialData?.selecetdStaffData?.firstName)} {capitalizeFirstLetter(initialData?.selecetdStaffData?.lastName)}</p>
            <p className='text-[#818181] text-[15px]'>{capitalizeFirstLetter(initialData?.selecetdStaffData?.designation?.designationName)}</p>
        </div>
        <hr className='w-5/6 mx-auto' />
        <div className='mt-2.5'>
            <p className='text-xs text-[#2692D9] mb-2'>Change Shift</p>
            <Radio.Group
                value={selectedShift}
                onChange={handleShiftChange}
                className="flex flex-nowrap p-0 overflow-auto slimScroll gap-2"
              >
                {shift?.map((data,index) => (
                  <div className='text-center'>
                    <Radio.Button className="!text-sm whitespace-nowrap !text-[black] !border-[2px] !border-transparent !h-auto !leading-none !bg-[#E9F1FC] min-w-[54px] px-2.5 py-[12px] rounded-md [&.ant-radio-button-wrapper-checked]:!border-[#4B8AEB]" value={data?.shiftId}>
                      {data?.shiftFullName}
                    </Radio.Button>
                    <p className='text-xs text-gray-500 leading-none my-0.5'>{formatTimeWithAMPM(data?.shiftStartTime)}</p>
                    <p className='text-xs text-gray-500 leading-none my-0.5'>{formatTimeWithAMPM(data?.shiftEndTime)}</p>
                  </div>
                  ))}
              </Radio.Group>
        </div>
        <div className='my-3'>
        <Dropdown overlay={locationMenu} trigger={['click']} onOpenChange={handleOpenChange} open={openLocationDropdown} placement="bottom">
            <Button className='border-[#2692D9] rounded-full py-1 pl-3 pr-2 h-auto !text-xs text-[#2692D9] !outline-none flex items-center'>Change location <img src={DownArrow} sizes='12' className='ml-[3px]'/></Button>
        </Dropdown>
        </div>
        <div className='mb-3'>
        <Radio.Group onChange={onChange} value={value}>
          <Space direction="vertical">
            <Radio className='!text-[14px]' value={RULE_TYPE.All_Future_Days}>Change for all future dates for {getDayName(initialData?.item?.logDate)}</Radio>
            <Radio className='!text-[14px]' value={RULE_TYPE.This_Day}>Change only shift on this day</Radio>
            <Radio className='!text-[14px]' value={RULE_TYPE.All_Future_Dates}>Change shift for all future dates</Radio>
          </Space>
        </Radio.Group>
        </div>
        <div className='modelBtns mt-1'>
        <Button className='w-36 h-[46px] bg-[#DBE8FB] rounded-full !border-none !outline-none !text-black' onClick={closeModel}>Discard</Button>
        <Button className='w-36 h-[46px] bg-[#4B8AEB] rounded-full !border-none !outline-none !text-white' onClick={saveShiftPlan}>Save</Button>

        </div>
    </div>
  </div>
  </Modal>
  );
};

export default ShiftPlanModel;
